import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=e5db7332"
import script from "./CompanyProfile.vue?vue&type=script&lang=js"
export * from "./CompanyProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports